import React from 'react';
import Layout from '../../components/common/pageLayout';
import Form from '../../components/Document/form';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v3_edit_document } from '../../actions/v3/document';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const EditDocument = (props) => {
    const location = useLocation();
    const { data: encodedDocument, document, projectData: encodedProjectData, selectedShip } = location.state || {};

    if ((!encodedDocument && !document) || !encodedProjectData) {
        return (
            <Layout title="Edit Document">
                <div className="alert alert-warning mb-0">
                    Document details are not available. Please open edit from the document list.
                </div>
            </Layout>
        );
    }

    const documentData = document || JSON.parse(atob(encodedDocument));
    const projectData = JSON.parse(atob(encodedProjectData));
    const documentId = documentData.DOCUMENT_ID || documentData.ID;

    const onSubmit = (model) => {
        v3_edit_document(documentId, model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.shipDocument.url, {
                    data: encodedProjectData,
                    selectedShip
                });
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title={`Edit Document | ${projectData.PROJECT_NAME}`}>
                <Form
                    data={documentData}
                    projectId={projectData.PROJECT_ID}
                    encodedData={encodedProjectData}
                    selectedShip={selectedShip}
                    onSubmit={onSubmit}
                    buttonName="Save Document"
                />
            </Layout>
        </React.Fragment>
    );
};

export default EditDocument;
